"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.App = void 0;
var _mui = require("@ori-ui/mui");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _shoppingContext = require("@ori/shopping-context");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _constants = require("../constants");
var _logger2 = require("../logger");
var _Merchandising = require("./Merchandising");
var _jsxRuntime = require("react/jsx-runtime");
const WELCOME_PROGRAM_CATEGORY = 'WelcomeProgram';
const ADVICE_HINT_TYPE = 'Advice';
const App = (param)=>{
    let { ordersPageLink } = param;
    const { shoppingContext } = (0, _shoppingContext.useShoppingContext)();
    const pendingOrdersAmount = (0, _react.useMemo)(()=>{
        var _shoppingContext_unitDataCollection_filter_map_;
        return (_shoppingContext_unitDataCollection_filter_map_ = shoppingContext === null || shoppingContext === void 0 ? void 0 : shoppingContext.unitDataCollection.filter((x)=>x.unitName === 'EndConsumerPendingOrders').map((x)=>x.notApprovedPendingOrders)[0]) !== null && _shoppingContext_unitDataCollection_filter_map_ !== void 0 ? _shoppingContext_unitDataCollection_filter_map_ : [];
    }, [
        shoppingContext
    ]);
    var _shoppingContext_shoppingMessages;
    const messages = ((_shoppingContext_shoppingMessages = shoppingContext === null || shoppingContext === void 0 ? void 0 : shoppingContext.shoppingMessages) !== null && _shoppingContext_shoppingMessages !== void 0 ? _shoppingContext_shoppingMessages : []).filter((x)=>x.hintType !== ADVICE_HINT_TYPE || x.hintCategory !== WELCOME_PROGRAM_CATEGORY);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
        logger: _logger2.mainLogger,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
            areaName: "".concat(_constants.APP_NAME, "-boundary"),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.ThemeProvider, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
                    namespace: _constants.translationsNamespace,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
                        project: _constants.APP_NAME,
                        team: _testidGenerator.Team.Checkout,
                        children: messages.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Merchandising.Merchandising, {
                            messages: messages,
                            ordersAmount: pendingOrdersAmount.length,
                            ordersPageLink: ordersPageLink,
                            pendingOrders: pendingOrdersAmount
                        })
                    })
                })
            })
        })
    });
};
exports.App = App;
var _default = exports.default = App;
